import {
  ApplicationConfig,
  LOCALE_ID,
  provideEnvironmentInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import {routes} from './app.routes';
import {provideHttpClient, withInterceptors, withXhr} from '@angular/common/http';
import {errorInterceptor} from './core/error-interceptor.service';
import {provideEnvironmentNgxMask} from 'ngx-mask';
import {provideOAuthClient} from 'angular-oauth2-oidc';
import {
  provideRouter,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';
import {tokenInterceptor} from './core/token.interceptor';
import {apiBaseUrlInterceptor} from './core/api-base-url.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(withXhr(), withInterceptors([apiBaseUrlInterceptor, tokenInterceptor, errorInterceptor])),
    provideOAuthClient(),
    provideEnvironmentNgxMask(),
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
      withComponentInputBinding(),
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      })
    ),

    // other 3rd party libraries providers like NgRx, provideStore()

    // other application specific providers and setup

    {provide: LOCALE_ID, useValue: 'de-DE'},
    // perform initialization, has to be last
    provideEnvironmentInitializer(() => {
      // add init logic here...
      // kickstart processes, trigger initial requests or actions, ...
    }),
  ],
};
